import axios from 'axios';
import { clearLegacyAuthStorage } from '@/lib/clearLegacyAuthStorage';

const mapi = axios.create({
  baseURL: `${(process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '')}/api/v1`,
  withCredentials: true, // HttpOnly mamv_access
  timeout: 15000,
});

mapi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith('/m')
        && !window.location.pathname.startsWith('/m/login')) {
      clearLegacyAuthStorage();
      window.location.href = '/m/login';
    }
    return Promise.reject(err);
  }
);

export default mapi;
